/* eslint-disable react-hooks/exhaustive-deps */
import { PageProps } from 'models/page';
import React, { useEffect, useState } from 'react';
import { CustomerPermission, InitContextProps, useAuthContext } from 'services/context/authentication.context';
import { CustomerContactsTable } from '../components/CustomerContacts/CustomerContactsTable';
import CustomerContactService from '../services/customer-contact.service';
import { ModifyCustomerContactModal } from '../components/CustomerContacts/modals/ModifyCustomerContactModal';
import { DeleteCustomerContactModal } from '../components/CustomerContacts/modals/DeleteCustomerContactModal';
import { CustomerContactPerson } from 'models/contact-person';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export function CustomerContacts(props: PageProps) {
    const { state, hasPermission }: InitContextProps = useAuthContext();
    const { customerId, customer } = state;

    const [customerContacts, setCustomerContacts] = useState<CustomerContactPerson[] | null>(null);
    const [isRequesting, setIsRequesting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedContact, setSelectedContact] = useState<CustomerContactPerson | undefined>(undefined);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    let history = useHistory();

    const findCustomerContacts = async () => {
        try {
            setIsRequesting(true);

            const res = await CustomerContactService.getCustomerContacts(customerId!);

            setCustomerContacts(res);
        } catch(e) {
            console.error(e);
        } finally {
            setIsRequesting(false);
        }
    };

    useEffect(() => {
        props.onLoadValidatePage();
        findCustomerContacts();
    }, []);

    useEffect(() => {
        if (state.customer && !hasPermission(CustomerPermission.REPRESENTATIVE)) history.push("/");
    }, [state.customer])

    const existingContactCodes = customerContacts?.map(contact => contact.personalIdentificationCode);
    
    return (
      <>
        <div className="customer-contacts__container">
          <h2>Kasutajad</h2>
          <div className="customer-contacts__button-bar">
              <Button
                  variant="primary"
                  className="h-100"
                  type="button"
                  onClick={() => { setSelectedContact(undefined); setShowModal(true); }}
              >
                <span className="px-3">
                  Lisa kasutaja
                </span>
              </Button>
          </div>
          <CustomerContactsTable
             customerContacts={customerContacts}
             isRequesting={isRequesting}
             onEdit={(contact) => { setSelectedContact(contact); setShowModal(true); }}
             onDelete={(contact) => { setSelectedContact(contact); setShowDeleteModal(true); }}
             currentContactId={customer?.contactId}
          />
        </div>
          {
            showModal && (
              <ModifyCustomerContactModal
                  handleModalHide={() => { setShowModal(false); setSelectedContact(undefined); }}
                  onSubmitSuccess={() => findCustomerContacts()}
                  contact={selectedContact} 
                  existingContactCodes={existingContactCodes}
              />
            )
          }
          {
            showDeleteModal && selectedContact && (
              <DeleteCustomerContactModal
                  contact={selectedContact}
                  handleModalHide={() => { setShowDeleteModal(false); setSelectedContact(undefined); }}
                  onDeleteSuccess={() => findCustomerContacts()}
              />
            )
          }
      </>
    )
}